<script setup lang="ts">
import type { ArticleRecord } from '~/types/datocms'
import { CardType } from '~/types'

export type ArticleListLayout = 'mixed' | 'news-latest'

interface ArticleListProps {
  type?: CardType | undefined
  layout?: ArticleListLayout
  data: ArticleRecord[]
  isLoading: boolean
  noRecordsMessage?: string
}

const props = withDefaults(defineProps<ArticleListProps>(), {
  type: undefined,
  layout: 'mixed',
  noRecordsMessage: 'No records to display'
})

const setCartType = (idx: number): CardType => {
  if (props.type) {
    return props.type
  } else {
    return idx === 0 ? CardType.NEWS_EXPOSED : idx <= 2 ? CardType.NEWS_LATEST : CardType.NEWS
  }
}
</script>

<template>
  <div>
    <Transition
      mode="out-in"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
      enter-active-class="transition-opacity duration-300"
      leave-active-class="transition-opacity duration-300"
    >
      <div v-if="isLoading" class="py-10">
        <Spinner />
      </div>
      <div v-else>
        <template v-if="data.length === 0">
          <div class="text-bold py-10 text-center font-bold uppercase">{{ noRecordsMessage }}</div>
        </template>
        <template v-else>
          <TransitionGroup
            appear
            tag="div"
            class="grid grid-cols-12 gap-x-4 gap-y-8 lg:gap-x-5 lg:gap-y-10"
            enter-from-class="opacity-0"
            enter-active-class="transition-transform duration-300"
          >
            <ArticleListItem
              v-for="(item, idx) in data"
              :key="item.id"
              :data="item"
              class="col-span-full"
              :type="setCartType(idx)"
              :class="{
                'md:col-span-6':
                  props.type === CardType.NEWS_LATEST || (props.layout === 'mixed' && idx >= 1)
              }"
            />
          </TransitionGroup>
        </template>
      </div>
    </Transition>
  </div>
</template>
